import { PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'
import BrandCreationModal from '@/components/EntityCreationModals/BrandCreationModal/BrandCreationModal'
import type { SelectFormControlType } from '@/types'

import type { NomenclatureDictionaries } from '../hooks/useNomenclatureDictionaries'
import type { NomenclatureCreationType } from '../SingularImport.config'
import cn from './NomenclatureCreationForm.module.scss'

type BrandFieldProps = {
  form: UseFormReturn<NomenclatureCreationType>
  dictionaries: NomenclatureDictionaries
  isOrganisationSelected: boolean
}

function BrandField({
  form,
  dictionaries,
  isOrganisationSelected,
}: BrandFieldProps) {
  const [isCreateOpen, setIsCreateOpen] = useState(false)

  return (
    <div className={cn.fieldWithAction} onMouseEnter={dictionaries.loadBrands}>
      <HoverElement>
        <AtomSelect
          layout="stacked"
          fullWidth
          openByHover={false}
          showSearch
          required
          title="Бренд"
          placeholder="Выберите бренд"
          isOrganisationSelected={isOrganisationSelected}
          options={dictionaries.brands.map((brand) => ({
            value: brand.id,
            label: brand.description,
          }))}
          formName="brand"
          formControl={form.control as SelectFormControlType}
          formErrors={form.formState.errors}
        />
      </HoverElement>
      <AtomButton
        variant="secondary"
        shape="circle"
        icon={<PlusOutlined />}
        aria-label="Создать бренд"
        title="Создать бренд"
        className={cn.actionButton}
        onClick={() => setIsCreateOpen(true)}
      />
      <BrandCreationModal
        open={isCreateOpen}
        setOpen={setIsCreateOpen}
        onSuccess={dictionaries.reloadBrands}
      />
    </div>
  )
}

export default BrandField
